module.exports = __webpack_public_path__ + "img/icon_news.e5bd0796.jpg";